import { SxProps } from '@mui/material';
import {
  GridToolbarQuickFilter,
  GridToolbarQuickFilterProps,
} from '@mui/x-data-grid-pro';

import { COLORS } from '@/styles/tokens/colors';

const QUICK_FILTER_SEARCHBAR_SX: SxProps = {
  background: COLORS.PRIMITIVES.WHITE,
  padding: 0,
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: COLORS.GRAY[300],
  },
  '& .MuiOutlinedInput-root .MuiSvgIcon-root': {
    fill: COLORS.NAVY[700],
  },
  '& input': {
    marginLeft: 0,
  },
};

export function QuickFilterSearchbar({
  sx,
  ...props
}: GridToolbarQuickFilterProps) {
  const sxOverrides = Array.isArray(sx) ? sx : [sx];

  return (
    <GridToolbarQuickFilter
      sx={[QUICK_FILTER_SEARCHBAR_SX, ...sxOverrides]}
      {...props}
    />
  );
}
